import React, { useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';

const AddCourseModal = ({ show, onClose, courses, userId, userToken, t, toPlainOptionLabel }) => {
    const [addCourseId, setAddCourseId] = useState("");
    const [addSubjects, setAddSubjects] = useState([]);
    const [addSelectedSubjectId, setAddSelectedSubjectId] = useState("");

    const getAuthHeaders = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + userToken
    });

    const fetchModalSubjects = async (courseId) => {
        if (!courseId) {
            setAddSubjects([]);
            return;
        }
        try {
            const res = await axios({
                method: 'GET',
                url: "https://api.heryerdeingilizce.com/api/admin/SubjectManager/GetListByCourse",
                headers: getAuthHeaders(),
                params: { id: courseId }
            });

            if (res.status === 200 && res.data['success']) {
                setAddSubjects((res.data?.data || []).filter((item) => item?.isActive));
            } else {
                setAddSubjects([]);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddCourseChange = async (e) => {
        const courseId = e.target.value;
        setAddCourseId(courseId);
        setAddSelectedSubjectId("");
        await fetchModalSubjects(courseId);
    };

    const handleAddUserCourse = async () => {
        if (!addCourseId) {
            Swal.fire({ title: "Lütfen kurs seçiniz.", icon: "warning", confirmButtonText: "Tamam" });
            return;
        }

        try {
            const res = await axios({
                method: 'POST',
                url: "https://api.heryerdeingilizce.com/api/admin/User/AddUserCourse",
                headers: getAuthHeaders(),
                data: {
                    userId: parseInt(userId),
                    courseId: parseInt(addCourseId)
                }
            });

            if (res.status === 200 && res.data?.success) {
                Swal.fire({
                    title: "Kurs başarıyla eklendi!",
                    icon: "success",
                    confirmButtonText: "Tamam",
                    timer: 2500
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire({ title: res.data?.message || "Kurs eklenemedi.", icon: "error", confirmButtonText: "Tamam" });
            }
        } catch (err) {
            Swal.fire({ title: err?.message || "Kurs eklenemedi.", icon: "error", confirmButtonText: "Tamam" });
        }
    };

    if (!show) return null;

    return (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Kurs Ekle</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">{t("selectCourse")}</label>
                            <select className="form-select" style={{ textOverflow: "ellipsis", maxWidth: "100%" }} value={addCourseId} onChange={handleAddCourseChange}>
                                <option value="">{t("selectCourse")}</option>
                                {courses.map((course) => {
                                    const fullText = toPlainOptionLabel(`${course.courseName} - ${course.courseDesc}`);
                                    const truncatedText = fullText.length > 55 ? fullText.substring(0, 55) + "..." : fullText;
                                    return (
                                        <option key={course.id} value={course.id} title={fullText}>
                                            {truncatedText}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t("selectSubject")}</label>
                            <select className="form-select" style={{ textOverflow: "ellipsis", maxWidth: "100%" }} value={addSelectedSubjectId} onChange={(e) => setAddSelectedSubjectId(e.target.value)} disabled={!addCourseId}>
                                <option value="">{t("selectSubject")}</option>
                                {addSubjects.map((subject) => {
                                    const fullText = toPlainOptionLabel(`${subject.subjectName} - ${subject.subjectDesc}`);
                                    const truncatedText = fullText.length > 55 ? fullText.substring(0, 55) + "..." : fullText;
                                    return (
                                        <option key={subject.id} value={subject.id} title={fullText}>
                                            {truncatedText}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <small className="text-muted">Kurs ekleme işlemi seçilen courseId ile yapılacaktır.</small>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Kapat</button>
                        <button type="button" className="btn btn-primary" onClick={handleAddUserCourse}>Kursu Ekle</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddCourseModal;